export enum APP_STORE {
  USER = 'user',
  ROLE = 'role',
}
